import React, { useEffect, useRef, useState } from "react";
import Switch from "components/switch";
import { urls } from "helpers/urls";
import Request from "helpers/request";
import { Radio, Row, Col } from "antd";
import ChatbotWidget from "components/ChatbotWidget";
import CommonNotification from "components/common/CommonNotification";
import ColorPicker from "components/common/ColorPicker";

const Info = ({
  id,
  widgetName,
  widgetCode,
  widgetPosition,
  setWidgetPosition,
}) => {
  const [appearance, setAppearance] = useState([]);

  const [headerColor, setHeaderColor] = useState("");
  const [agentMessageColor, setAgentMessageColor] = useState("");
  const [agentTextColor, setAgentTextColor] = useState("");
  const [widgetIcon, setWidgetIcon] = useState(null);
  const [widgetIconColor, setWidgetIconColor] = useState("");

  const [isActive, setIsActive] = useState(true);
  const [isCopied, setIsCopied] = useState(false);
  const [input, setInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [liked, setLiked] = useState(false);
  const [disliked, setDisliked] = useState(false);
  const [copiedMsg, setCopiedMsg] = useState(false);
  const messagesEndRef = useRef(null);

  const [widgetname, setWidgetName] = useState("");


  const getAppearance = async (site_id) => {
    try {
      const response = await Request.get(
        urls.createSite + `/${site_id}/appearance`
      );
      console.log(response);
      if (response.data && response.data.success) {
        setAppearance(response.data.data);
      } else {
        setAppearance([]);
      }
    } catch (error) {
      console.error("Error fetching sites:", error);
      setAppearance([]);
    }
  };

  const updateappearance = async (site_id) => {
    try {
      console.log("site_id", site_id);
      const response = await Request.patchJson(
        urls.createSite + `/${site_id}/update-appearance`,
        {
          header_color: headerColor,
          agent_message_color: agentMessageColor,
          agent_text_color: agentTextColor,
          icon_color: widgetIconColor,
          icon: widgetIcon,
          position: widgetPosition,
          status: isActive,
          name: widgetname,
        }
      );
      console.log(response);
      if (response.data && response.data.success) {
        setAppearance(response.data.data);
        CommonNotification.success("Widget updated successfully");
      } else {
        setAppearance([]);
        CommonNotification.error("Widget updated failed");
      }
    } catch (error) {
      console.error("Error fetching sites:", error);
      setAppearance([]);
      CommonNotification.error("Widget updated failed");
    }
  };

  const appearanceData = appearance;

  useEffect(() => {
    if (id) {
      getAppearance(id);
    }
  }, [id]);

  useEffect(() => {
    if (appearanceData) {
      setWidgetPosition(appearanceData.position);
      setIsActive(appearanceData.status);
      setHeaderColor(appearanceData.header_color);
      setAgentMessageColor(appearanceData.agent_message_color);
      setAgentTextColor(appearanceData.agent_text_color);
      setWidgetIcon(appearanceData.icon);
      setWidgetIconColor(appearanceData.icon_color);
      setWidgetName(appearanceData.name);
    }
  }, [appearanceData]);


  return (
    <><div className="appearance-section-wrap">
      <Row gutter={[45, 45]} style={{marginLeft: "0", marginRight: "0"}}>
        <Col xs={24} md={14} className="appearnce-section-col">
          <Row gutter={[45, 45]}>
            <Col span={12}>
              <label className="mb-2 block font-semibold">Widget ID</label>
              <input
                type="text"
                placeholder="Widget ID"
                className="w-full cursor-not-allowed rounded-md border border-gray-200 p-2"
                value={appearanceData?.widget_id}
                readOnly
                disabled />
            </Col>
            <Col span={12}>
              <label className="mb-2 block font-semibold">Widget Name</label>
              <input
                type="text"
                placeholder="Widget Name"
                className="w-full rounded-md border border-gray-200 p-2"
                value={widgetname}
                onChange={(e) => setWidgetName(e.target.value)} />
            </Col>
            <Col span={12}>
              <label className="mb-2 block font-semibold">Widget Status</label>
              <div className="flex items-center gap-2">
                <Switch
                  checked={isActive}
                  onChange={() => setIsActive(!isActive)} style={{
                    backgroundColor: "#2369d2",
                  }} />
                <span className="font-normal">
                  {isActive ? "Active" : "Inactive"}
                </span>
              </div>
            </Col>
            <Col span={12}>
              <label className="mb-2 block font-semibold">Widget Position</label>
              <Radio.Group
                options={[
                  { label: "Bottom Right", value: "bottom-right" },
                  { label: "Bottom Left", value: "bottom-left" },
                ]}
                value={widgetPosition}
                onChange={(e) => setWidgetPosition(e.target.value)} />
            </Col>

            <Col span={24}>
              <label className="mb-2 block font-semibold">Widget Icon</label>
              <input
                type="file"
                className="w-full rounded-md border border-gray-200 p-2 text-sm"
                accept="image/*"
                onChange={(e) => {
                  if (e.target.files && e.target.files[0]) {
                    let reader = new FileReader();
                    reader.onload = (ev) => {
                      setWidgetIcon(ev.target.result);
                    };
                    reader.readAsDataURL(e.target.files[0]);
                  }
                } } />
            </Col>

            <Col span={24}>
              <label className="mb-2 block font-semibold">Widget Colors</label>
              <Row gutter={[40, 40]} style={{gap: "0px 30px"}}>
                <Col>
                  <ColorPicker
                    label="Header Color"
                    value={headerColor}
                    onChange={setHeaderColor}
                  />
                </Col>
                <Col>
                  <ColorPicker
                    label="Agent Message Color"
                    value={agentMessageColor}
                    onChange={setAgentMessageColor}
                  />
                </Col>
                <Col>
                  <ColorPicker
                    label="Agent Text Color"
                    value={agentTextColor}
                    onChange={setAgentTextColor}
                  />
                </Col>
                <Col>
                  <ColorPicker
                    label="Icon Color"
                    value={widgetIconColor}
                    onChange={setWidgetIconColor}
                  />
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <div>
              <label className="mb-2 block font-semibold">Widget Code</label>
              <div className="relative">
                <textarea
                  className="w-full rounded-md border border-gray-200 p-2 pr-12"
                  value={widgetCode}
                  readOnly
                  rows={4} />
                <button
                  className="absolute top-2 right-2 rounded-md bg-gray-200 p-1 text-sm"
                  onClick={() => {
                    navigator.clipboard.writeText(widgetCode);
                    setIsCopied(true);
                    setTimeout(() => setIsCopied(false), 2000);
                  } }
                >
                  {isCopied ? "Copied!" : "Copy"}
                </button>
              </div>
              </div>
            </Col>

            <Col span={24}>
              <div className="integration-instructions py-6 border-t border-gray-200">
                <h2 className="text-xl font-semibold mb-4">Integration Instructions</h2>
                <div className="grid md:grid-cols-3 gap-6">
                  <div className="card p-4 border border-gray-200 rounded-lg shadow-sm">
                    <h3 className="font-semibold text-md mb-2">Copy the widget code</h3>
                    <p className="text-sm text-gray-500">Use the copy button above to copy the widget code to your clipboard</p>
                  </div>
                  <div className="card p-4 border border-gray-200 rounded-lg shadow-sm">
                    <h3 className="font-semibold text-md mb-2">Paste into your website</h3>
                    <p className="text-sm text-gray-500">Add the widget code to any HTML page where you want the chatbot to appear</p>
                  </div>
                  <div className="card p-4 border border-gray-200 rounded-lg shadow-sm">
                    <h3 className="font-semibold text-md mb-2">Test your integration</h3>
                    <p className="text-sm text-gray-500">Visit your website and test the chatbot to ensure it is working correctly</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col span={24}>
              <button
                className="w-full rounded-md bg-[#2369d2] p-2 text-white transition hover:bg-[#2369d2]/70 appearance-save-btn"
                onClick={() => updateappearance(id)}
              >
                Save
              </button>
            </Col>
          </Row>
        </Col>
        <Col xs={24} md={10}>
          <ChatbotWidget
            isOpen={true}
            isSticky={false}
            widgetPosition={widgetPosition}
            headerColor={headerColor}
            agentMessageColor={agentMessageColor}
            agentTextColor={agentTextColor}
            widgetIconColor={widgetIconColor}
            widgetIcon={widgetIcon}
            input={input}
            setInput={setInput}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            messagesEndRef={messagesEndRef}
            bot_type="readonly"
            liked={liked}
            setLiked={setLiked}
            disliked={disliked}
            setDisliked={setDisliked}
            copiedMsg={copiedMsg}
            setCopiedMsg={setCopiedMsg} />
        </Col>
      </Row>
    </div>

    </>
  );
};

export default Info;
